import { useDescargablesContext } from '../../../context/DescargablesContext'
import CustomTable from '../../Custom/Table'
import useDescargablesTable from './useDescargablesTable'
import { DescargablesI } from '../../../models/descargables'

interface Props {
    descargablesFiltrados?: DescargablesI
}

const DescargablesTable = ({ descargablesFiltrados }: Props) => {


    const { columns } = useDescargablesTable()
    const { descargables } = useDescargablesContext()

    // Si se pasan descargables filtrados, usarlos; si no, usar la lógica original
    const descargablesToShow = descargablesFiltrados || 
        [...descargables].filter(des => des.activo)
            .sort((a, b) => new Date(b.fechaRegistro).getTime() - new Date(a.fechaRegistro).getTime())
        


    return <CustomTable rows={descargablesToShow} columns={columns} />
}

export default DescargablesTable